module.exports = __webpack_public_path__ + "img/994a31fae0363416fcfebe36f1bc11d0.png";


//////////////////
// WEBPACK FOOTER
// ./components/levels/levelPrologue/assets/images/background-cloud.png
// module id = 83
// module chunks = 0